module.exports = __webpack_public_path__ + "contest-rules.pdf?6653da27379687e63689dabcd45b9fa3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/contest-rules.pdf
// module id = 156
// module chunks = 0